<template lang="html">
  <section class="dialogWrap articlePreviewWrap">
    <el-dialog  lock-scroll center  :close-on-click-modal="false" :close-on-press-escape="false" title="文章预览"
                :visible.sync="visible" width="1226px" top="5vh">
      <section class="dialogCont">

        <section class="articlePreviewCont">
          <section class="articlePreviewBox">
            <div class="title">{{articleInfo.title}}</div>
            <div class="time">时间：{{articleInfo.time}}</div>
            <section class="articleText" v-html="articleInfo.text"></section>
          </section>
        </section>



      </section>

    </el-dialog>
  </section>
</template>
<script>
export default {
  name: "articlePreview",
  props:{
    articleInfo:{
      type:Object,
      required:true,
    }
  },
  data(){
    return{
      visible:false,
    }
  },
  mounted() {},
  updated(){

  },
}
</script>

<style lang="css" scoped>
 @import "../config/css/dialog.css";

.articlePreviewWrap{}

 .dialogWrap /deep/  .el-dialog{
   background-color: #e2dcd3;
 }

.dialogCont{
  background-color: #e2dcd3;
}


.articlePreviewCont{
  width: 1166px;
  margin: 0 auto;
  border: 1px dashed #78201F;
  padding-bottom: 100px;
  box-sizing: border-box;
}
.articlePreviewBox{
  width: 800px;
  padding-top: 50px;
  margin:  0 auto;
}
.title{
  text-align: center;
  font-size: 34px;
  line-height: 50px;
  color: #0B0E28;
  text-align: center;
}
.time{
  font-size: 20px;
  line-height: 40px;
  color: #0B0E28;
  text-align: center;
  padding-bottom: 50px;
}
.articleText{
  width: 800px;
}


</style>
